export const PROFESSIONAL_TOPPING_NAME = "PROFESSIONAL";

export enum ServiceDurationOptionEnum {
  None = "none",
  One = "one",
  Two = "two",
  Three = "three",
  Other = "other",
}
